import {SetGetCreditLimits} from './thunk/setGetCreditLimits';
import {SetGetCreditLive} from './thunk/setGetCreditLive';
import {SetGetListGroups} from './thunk/setGetListGroups';

export const Thunks = {
    SetGetCreditLimits,
    SetGetCreditLive,
    SetGetListGroups
}